import React from 'react';
import stylesPlain from '../../components/plain/plain.module.css';

import PlainPage from '../../components/plain/PlainPage';
import FieldString from '../../components/plain/FieldString';
import FieldEnum from '../../components/plain/FieldEnum';
import FieldObject from '../../components/plain/FieldObject';
import DivOrganization, {validateOrganization} from './components/DivOrganization';
import FieldList_Strings from '../../components/plain/FieldList_Strings';

import {getLanguage} from '../../util/localStorage';
import {CLASS_EBOOK_BANK, CLASS_ORGANIZATION } from '../../util/consts/classes';
import {FORM_EBOOK_BANK_PLAIN, FORM_ORGANIZATION_TABLE} from '../../util/consts/forms';
import {ORGANIZATION_PLAIN_PATH} from '../../util/routes';

class EBookBankPlainPage extends PlainPage {
	
	constructor(props) {
		super(props);
		this.formPath = FORM_EBOOK_BANK_PLAIN;
		this.formTitle = 'Фінансова установа';
		this.buildInstanceCard = this.buildEBookBankCard;
	}
	componentDidMount = async () => {
		this.init( CLASS_EBOOK_BANK );
		document.title = 'BOM. ' + this.formTitle;
	}
	
	buildEBookBankCard = (bankInstance) => {
		let card = '';
		let currentLanguage = getLanguage();
		let name = null;
		for(let n of bankInstance.rootField.value.organization.value.names.value) {
			if( n.value.language.value == currentLanguage && n.value.name.value ) {
				name = n;
				break;
			}
		}
		if( name == null && bankInstance.rootField.value.organization.value.names.value.length > 0)
			name = bankInstance.rootField.value.organization.value.names.value[0];
		if( name != null ) {
			if( name.value.name.value )
				card += name.value.name.value;
			else if( name.value.shortName.value )
				card += name.value.shortName.value;
		} 
		return card;
	}
	
	validateInstance() {
		return validateOrganization(this.instance, this.instance.rootField.value.organization);
	}
	
	renderBody() {
		let instance = this.state.instance;
		let fieldGroup = instance.rootField;
		let readOnly = this.instanceReadOnly;
		let fieldOrganization = instance.rootField.value.organization;
		return (
			<div className={stylesPlain.divPlainMain} style={{width: '1500px'}}>
				{this.renderHeader()}
				
				{/* Body */}
				<div className={stylesPlain.divPlainBody} >
					
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldEnum instance={instance} path={'bankStatus'} parentField={fieldGroup} plain={this}
							readOnly={readOnly}
							styles={{ select: {flexGrow: '0', marginRight: '20px'}}}
						/>
						<FieldString instance={instance} path={'code'} parentField={fieldGroup} plain={this}
							readOnly={readOnly}
							styles={{ input: {flexGrow: '0', width: '600px'}}}
						 />
					</div>

					<div style={{display: 'flex', marginBottom: '15px'}}>
						
						<div style={{flexGrow: "1", padding: '20px', border: '1px solid blue'}}>
							<div style={{marginBottom: '15px'}}>
								<FieldObject instance={instance} path={'organization'} plain={this} parentField={fieldGroup} 
									readOnly={readOnly}
									refNodes = {[
										{
											classId: CLASS_ORGANIZATION, plainFormPath: ORGANIZATION_PLAIN_PATH, 
											selectInstanceFormId: FORM_ORGANIZATION_TABLE,
											selectInstanceFormTitle: 'Організації'
										},
									]}
									styles={{label: {divMain: {marginRight: '10px', fontWeight: 'bold'}}}}
								/>
							</div>
							<DivOrganization instance={instance} fieldGroup={fieldOrganization} readOnly={readOnly} plain={this}/>
						</div>

						<div style={{flexGrow: "0", marginLeft: '20px'}}>
							<FieldList_Strings instance={instance} path={'aids'} parentField={fieldGroup} plain={this} 
								readOnly={readOnly}
							/>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default EBookBankPlainPage;
